export const environment = {
    production: true,
    admNome: 'Ascibras',
    apiUrl: 'https://api.g2saude.com.br/api/cliente',
    assets: 'ascibras',
    base: 'ascibras'
};
